import "rxjs/add/operator/map";
import { ajax } from "lib/observable";
import siteConfig from "site-config";
import { INSIGHTS } from "constants/action-types";
import type { IStore } from "reducers";
import type { IProductSizeInsightResponse } from "types/insights/product-size-insight";
import { SizeInsights } from "models/insights/size-insights";
import { Observable } from "rxjs/Observable";
import me from "models/me";
import { toggleCartInsightsSidePanelOpen } from "actions/insights-actions";

export const fetchProductSizeInsightsEpic = (action$, store) =>
    action$.ofType(INSIGHTS.FETCH_PRODUCT_SIZE_INSIGHTS.START).switchMap((action) => {
        const state: IStore = store.getState();
        const brandId = state.scope.brand._id;
        const sizeInsightsFeatureFlag = state.ldFlags.sizeInsightsNu67199;

        const payloadProductIds = action.payload.productIds;
        const productIds = Array.isArray(payloadProductIds) ? payloadProductIds : [payloadProductIds];

        const query = productIds.map((id) => `products=${id}`).join("&");

        if (!me.hasPermission("order_trends") || !sizeInsightsFeatureFlag || productIds.length === 0) {
            return [
                {
                    type: INSIGHTS.FETCH_PRODUCT_SIZE_INSIGHTS.FETCH_DISABLED,
                },
            ];
        }

        return ajax({
            url: `${siteConfig.orderInsightApi}/v1/insights/brand/${brandId}/sizes?${query}`,
            method: "GET",
            withCredentials: true,
            crossDomain: true,
            headers: {
                "Content-Type": "application/json",
            },
            handle401: true,
        })
            .flatMap(({ response, status }) => {
                if (status !== 200) {
                    throw new Error(response.message || "Unknown fetch error");
                }

                const productsSizes = response as IProductSizeInsightResponse;

                if (
                    window?.location?.pathname?.includes("/cart") &&
                    Object.keys(productsSizes).length > 0 &&
                    !me.getHasSizeInsightsBeenSeen()
                ) {
                    me.setSizeInsightsBeenSeen(true);
                    store.dispatch(toggleCartInsightsSidePanelOpen());
                }

                return [
                    {
                        type: INSIGHTS.FETCH_PRODUCT_SIZE_INSIGHTS.COMPLETED,
                        productSizes: Object.fromEntries(
                            Object.entries(productsSizes).map(([productId, productResponseData]) => {
                                return [productId, new SizeInsights(productResponseData)];
                            }),
                        ),
                    },
                ];
            })
            .catch((error) => {
                return Observable.merge(
                    Observable.of({
                        type: INSIGHTS.FETCH_PRODUCT_SIZE_INSIGHTS.ERROR,
                        error: true,
                        payload: new Error(`Error fetching product size insights ${error.message}`),
                    }),
                );
            });
    });
